// extracted by mini-css-extract-plugin
module.exports = {"container":"NoRooms_container__BwuEH"};